import { Column, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from '../base.entity';
import { UserEntity } from '../user.entity';

/**
 * Abstract base entity for activity history.
 * Provides common columns used by all entity-specific activity tables.
 *
 * Each entity's activity table extends this and adds:
 * - The FK to the parent entity (e.g., fkIssueId, fkOpportunityId)
 * - The ManyToOne relation to the parent entity
 * - Entity-specific indexes
 */
export abstract class BaseActivityEntity extends BaseEntity {
	@Column('varchar', { name: 'activity_type', length: 50 })
	public activityType!: string;

	@Column('varchar', { name: 'entity_type', length: 50, nullable: true })
	public entityType!: string | null;

	@Column('int', { name: 'entity_id', unsigned: true, nullable: true })
	public entityId!: number | null;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('json', { name: 'metadata', nullable: true })
	public metadata!: Record<string, unknown> | null;

	@Column('int', { name: '_fk_user__id', nullable: true, unsigned: true })
	public fkUserId!: number | null;

	@ManyToOne(() => UserEntity, {
		onDelete: 'SET NULL',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;
}
